import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const ArrowLeftChunky = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <polygon
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            points="4,12 12,20 13.5,18.5 8,13 20,13 20,11 8,11 13.5,5.5 12,4 "
        />
    </svg>
);

export default ArrowLeftChunky;
